import React from 'react';
import youtubeImage from './../images/youtubeLogoSquare.png';

const YoutubeLink = ({channelId}) => {
    if (!channelId) return null;
    return (
        <a href={'https://www.youtube.com/channel/' + channelId} target='_blank' rel='noopener noreferrer'>
            <img className='socialImage' src={youtubeImage} alt='YouTube'/>
        </a>
    )
}

export default YoutubeLink;
